<template lang="pug" src="./infoOrder.pug"> </template>
<style lang="scss" src="./infoOrder.scss" scoped> </style>

<script>
import config from '../../../../../config.json';
import {VCol, VRow} from "vuetify/lib/components";

export default {
    components: {
      'v-col': VCol,
      'v-row': VRow
    },
    props: {
        activeOrder: {
            type: Object,
            required: false,
            default: null
        },
        orderHistories: {
            type: Array,
            required: false,
            default: null
        },
        type: {
            type: String,
            required: false,
            default: null
        },
        customerPhone: {
            type: [Number, String],
            default: config.defaultTaxiNumber
        },
        filterStatuses: {
            type: Boolean,
            default: false,
            required: false
        },
        isShow: {
            type: Boolean,
            required: false
        },
        isCalculatePosition: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        offsetTop: null,
        isShowOrderInfo: false,
        menu: false,
    }),
    computed: {
        sortedOrderHistory: function() {
            if (this.type === 'orderHistory') {
                return this.sortOrderHistory('deliveryStatus');
            } else if (this.type === 'clientStatusesHistory') {
                return this.sortOrderHistory('status');
            }
            return null;
        },
        isDelivery() {
            return (this.orderHistories || []).some(i => i.deliveryStatus !== null);
        },
        cancelDetails: function () {
            if (!this.activeOrder.orderCancelDetail) {
                return [];
            }

            const { questionType, explanation, isResolved } = this.activeOrder.orderCancelDetail;

            const translationPath = '$vuetify.pages.ReceiveOrders.cancelOrderDetails';
            const translate = (string) => this.$vuetify.lang.t(`${string}`);

            const resolvedText = isResolved ? 'resolved' : 'unresolved';

            const translation = {
                questionType: translate(`${translationPath}.questionsList.${questionType}`),
                explanation: translate(`${translationPath}.explanationsList.${explanation}`),
                isResolved: translate(`${translationPath}.${resolvedText}`)
            };

            return Object.keys(translation).map(it => ({
                translation: translation[it]
            }));
        }
    },
    methods: {
        async showOrderInfo() {
            if (this.type === 'orderHistory') {
                await this.$store.dispatch('orders/getOrderHistory', this.activeOrder.id);
            } else if (this.type === 'clientStatusesHistory') {
                await this.$store.dispatch('orders/getClientStatusesHistory', this.customerPhone);
            }
            this.isShowOrderInfo = true;
        },

        sortOrderHistory(type) {
            let statuses = this.orderHistories;

            if (this.filterStatuses) {
                statuses = this.orderHistories.filter((it, index, arr) => {
                    return index === 0 || it[type] != arr[index - 1][type];
                });
            }

            return statuses.map(function(it) {
                return { orderStatus: type === 'deliveryStatus' ? it.orderStatus : it[type], createdAt: it.createdAt, deliveryStatus: it.deliveryStatus };
            });
        },

        closeOrderInfo() {
            this.isShowOrderInfo = false;
        }
    }
};
</script>
